import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import styled from 'styled-components'

const Bubble = styled(Avatar)`
  background-color: ${props => props.color};
  height: ${props => props.theme.spacing(8)}px;
  width: ${props => props.theme.spacing(8)}px;
  border: 2px solid ${props => props.theme.palette.text.secondary};
`

const ThemeEditorColorBubble = props => <Bubble {...props} />

export default ThemeEditorColorBubble
